import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { NotificationManager } from 'react-notifications';
import Toggle from 'react-toggle';
import { NOT_REQUIRED, REQUIRED } from '../Constants';

const CategoryOptionsModal = ({
    showModal,
    handleClose,
    onSaveCategoryOption,
    assignment,
    categoriesArr,
    fcCount,
}) => {

    const [categories, setCategories] = useState(categoriesArr ? categoriesArr : [])
    const [isAllRequired, setIsAllRequired] = useState(true);
    const [freeChoiceCount, setFreeChoiceCount] = useState(fcCount);

    useEffect(() => {

        let required = true;
        for (let i = 0; i < categories.length; i++) {
            const element = categories[i];
            if (element.required === NOT_REQUIRED) {
                required = false;
                break;
            }
        }
        if (required) {
            setFreeChoiceCount(0);
        }
        setIsAllRequired(required);

    }, [categories])

    const handleSave = () => {
        let notRequiredCount = 0;
        let requiredCount = 0

        categories.forEach(cat => {
            if (cat.required === REQUIRED) {
                requiredCount += 1;
            } else {
                notRequiredCount += 1;
            }
        });

        console.debug("freeChoiceCount", freeChoiceCount, notRequiredCount)
        if (freeChoiceCount > notRequiredCount) {
            NotificationManager.error('Minimum number of Free Choice Categories required to be completed should not be greater than the total number of optional categories in this assignment');
            return;
        }

        if (freeChoiceCount < 1 && notRequiredCount === categories.length) {
            NotificationManager.error('Since you have only optional cateories in this assignment, the Minimum number of Free Choice Categories required to be completed should be greater than 0');
            return;
        }

        onSaveCategoryOption(categories, freeChoiceCount);
    }

    return (
        <Dialog
            open={showModal}
            fullWidth
            maxWidth={false}
            // maxWidth="lg"
            PaperProps={{
                sx: {
                    // minHeight: 600
                    width: 'auto'
                }
            }}
        >
            <DialogTitle>
                <Typography fontSize={18} fontWeight={600}>
                    Category Options
                </Typography>
            </DialogTitle>
            <IconButton
                aria-label="close"
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                })}
                onClick={handleClose}
            >
                <IoMdCloseCircleOutline fontSize={24} />
            </IconButton>

            <DialogContent>
                {!isAllRequired ?
                    <div style={{
                        marginBottom: "8px"
                    }}>
                        <div>
                            Minimum number of Free Choice Categories to be completed
                        </div>
                        <div>
                            (in addition to the required categories)
                            <TextField
                                sx={{
                                    width: "70px",
                                    marginLeft: "4px",
                                }}
                                value={freeChoiceCount}
                                onChange={e => {
                                    let value = parseInt(e.target.value);
                                    if (value <= 0) value = 1;
                                    setFreeChoiceCount(value);
                                }}
                                size='small'
                                type='number'
                            />
                        </div>
                    </div>
                    : null}
                <div className='matrix-table-container category-option-table'>


                    <table className="matrix-table">
                        <thead className='matrix-table-head'>
                            <tr className="matrix-row-header">
                                <th className="matrix-row-cell" style={{minWidth:"150px"}}>Subject</th>
                                <th className="matrix-row-cell" style={{minWidth:"150px"}}>Topic</th>
                                <th className="matrix-row-cell category-width">Categories</th>
                                <th
                                    key={0}
                                    className="matrix-row-cell"
                                    style={{
                                        minWidth: "100px",
                                    }}
                                >
                                    {assignment?.quiz_type === 1 ?
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            NOCQC
                                        </div>
                                        : <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            Mastery Condition
                                        </div>
                                    }
                                </th>
                                <th className="matrix-row-cell"
                                    style={{
                                        minWidth: "180px",
                                    }}>
                                    {assignment?.quiz_type === 1 ?
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            # of Questions
                                        </div>
                                        : <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            NOCQC
                                        </div>
                                    }
                                </th>
                                <th className="matrix-row-cell"
                                    style={{
                                        minWidth: "160px",
                                    }}>
                                    {assignment?.quiz_type === 1 ?
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            # of Available Questions
                                        </div>
                                        : <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            Random Subcategory Order
                                        </div>
                                    }
                                </th>
                                <th className="matrix-row-cell"
                                    style={{
                                        minWidth: "150px",
                                    }}>
                                    {assignment?.quiz_type === 1 ?
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            Random Subcategory Order
                                        </div>
                                        : <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            Required
                                        </div>
                                    }
                                </th>
                                <th className="matrix-row-cell"
                                    style={{
                                        minWidth: "100px",
                                    }}>
                                    <div className='category-header-tag cat-cell' onClick={() => { }}>
                                        At First
                                    </div>
                                </th>
                                <th className="matrix-row-cell"
                                    style={{
                                        minWidth: "100px",
                                    }}>
                                    <div className='category-header-tag cat-cell' onClick={() => { }}>
                                        At Last
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories.map((category, index) => {
                                console.debug("category>>??", category)
                                return (
                                    <tr className="matrix-row" key={index}>
                                        <td className="matrix-row-cell" style={{ textAlign: 'left'}}>
                                            <div className='category-name-cell'>
                                                <div className='category-name'>
                                                    {category.subject_name}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="matrix-row-cell" style={{ textAlign: 'left'}}>
                                            <div className='category-name-cell'>
                                                <div className='category-name'>
                                                    {category.topic_name}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="matrix-row-cell category-width" style={{ textAlign: 'left' }}>
                                            <div className='category-name-cell'>
                                                <div className='category-name'>
                                                    {category.category_name}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="matrix-row-cell">
                                            {assignment?.quiz_type === 1 ?
                                                <TextField size='small' type="number" sx={{ width: "50px" }} value={parseInt(category.nocqc)}
                                                    onChange={e => {
                                                        let updatedValue = parseInt(e.target.value);
                                                        if (updatedValue <= 0) updatedValue = 1;
                                                        let updatedCategories = [...categories];
                                                        updatedCategories[index].nocqc = updatedValue;
                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                                :
                                                <TextField size='small' type="number" sx={{ width: "50px" }}
                                                    value={parseInt(category.masteryCount)}
                                                    onChange={e => {
                                                        let updatedValue = parseInt(e.target.value);
                                                        if (updatedValue <= 0) updatedValue = 1;
                                                        let updatedCategories = [...categories];
                                                        updatedCategories[index].masteryCount = updatedValue;
                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                            }
                                        </td>
                                        <td className="matrix-row-cell">
                                            {assignment?.quiz_type === 1 ?
                                                <TextField size='small' type="number" sx={{ width: "50px" }}
                                                    value={parseInt(category.noOfQuestion)}
                                                    onChange={e => {
                                                        let updatedValue = parseInt(e.target.value);

                                                        //TODO: category.question_count is wrong because if 2 subcats are added
                                                        // then we have to count all the questions present in that subcat and use that here
                                                        // like we did in categoryModal.js
                                                        if (updatedValue <= 0) updatedValue = category.question_count;
                                                        let updatedCategories = [...categories];
                                                        updatedCategories[index].noOfQuestion = updatedValue;
                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                                :
                                                <TextField size='small' type="number" sx={{ width: "50px" }} value={parseInt(category.nocqc)}
                                                    onChange={e => {
                                                        let updatedValue = parseInt(e.target.value);
                                                        if (updatedValue <= 0) updatedValue = 1;
                                                        let updatedCategories = [...categories];
                                                        updatedCategories[index].nocqc = updatedValue;
                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                            }
                                        </td>
                                        <td className="matrix-row-cell">
                                            {assignment?.quiz_type === 1 ? category.question_count :
                                                <Toggle checked={category.randomSubcategoryOrder === 1} icons={false} className='custom-react-toggle'
                                                    onChange={() => {
                                                        let updatedValue = category.randomSubcategoryOrder === 1 ? 0 : 1;
                                                        let updatedCategories = [...categories];
                                                        updatedCategories[index].randomSubcategoryOrder = updatedValue;
                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                            }
                                        </td>
                                        <td className="matrix-row-cell">
                                            {assignment?.quiz_type === 1 ? <Toggle checked={category.randomSubcategoryOrder === 1} icons={false} className='custom-react-toggle' /> :
                                                <Toggle checked={category.required === REQUIRED} icons={false} className='custom-react-toggle'
                                                    onChange={() => {
                                                        let updatedValue = category.required === REQUIRED ? NOT_REQUIRED : REQUIRED;
                                                        let updatedCategories = [...categories];
                                                        if (updatedValue === NOT_REQUIRED) {
                                                            updatedCategories[index].atFirst = 0;
                                                            updatedCategories[index].atLast = 0;
                                                        }
                                                        updatedCategories[index].required = updatedValue;

                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                            }
                                        </td>
                                        <td className="matrix-row-cell">
                                            <Toggle checked={category.atFirst === 1} icons={false} className='custom-react-toggle'
                                                onChange={() => {
                                                    let updatedValue = category.atFirst === 1 ? 0 : 1;
                                                    let updatedCategories = [...categories];
                                                    if (updatedValue == 1) {
                                                        for (let i = 0; i < updatedCategories.length; i++) {
                                                            updatedCategories[i].atFirst = 0;
                                                            // updatedCategories[i].atLast = 0;
                                                        }
                                                        updatedCategories[index].required = 1;
                                                        updatedCategories[index].atLast = 0;
                                                    }

                                                    updatedCategories[index].atFirst = updatedValue;

                                                    if (updatedValue === 1) {
                                                        let temp = updatedCategories[0];
                                                        updatedCategories[0] = updatedCategories[index];
                                                        updatedCategories[index] = temp
                                                    }

                                                    setCategories(updatedCategories)
                                                }}
                                            />
                                        </td>
                                        <td className="matrix-row-cell">
                                            <Toggle checked={category.atLast === 1} icons={false} className='custom-react-toggle'
                                                onChange={() => {
                                                    let updatedValue = category.atLast === 1 ? 0 : 1;
                                                    let updatedCategories = [...categories];
                                                    if (updatedValue == 1) {
                                                        for (let i = 0; i < updatedCategories.length; i++) {
                                                            // updatedCategories[i].atFirst = 0;
                                                            updatedCategories[i].atLast = 0;
                                                        }
                                                        updatedCategories[index].required = 1;
                                                        updatedCategories[index].atFirst = 0;
                                                    }
                                                    updatedCategories[index].atLast = updatedValue;

                                                    if (updatedValue === 1) {
                                                        let l = updatedCategories.length;
                                                        let temp = updatedCategories[l - 1];
                                                        updatedCategories[l - 1] = updatedCategories[index];
                                                        updatedCategories[index] = temp
                                                    }

                                                    setCategories(updatedCategories)
                                                }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant='contained' onClick={handleSave}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CategoryOptionsModal;
